import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { StringAdapter } from "../StringAdapter";

import { PricingService } from "../../lookup/pricing/PricingService";
import { TranslateService } from "@ngx-translate/core";

// String types that are sortable as an Int32 in C++ module
export class TrackingSideAdapter extends StringAdapter {
  protected pricingService: PricingService;

  constructor(pricingService: PricingService, protected translate: TranslateService) {
    super();
    this.pricingService = pricingService;
  }

  retrieveData(order: CubiqTS.OrderDataImpl, columnProperty: string): string {
    let trackingSide: CubiqTS.RateSideType = this.pricingService.getBlotterTrackingSide(order);
    if (trackingSide != undefined && trackingSide != null) {
      return this.translate.instant("RateSideType." + CubiqTS.RateSideType[trackingSide]);
    }
    return "-";
  }
}
